import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SaleModel} from 'src/app/model/sale';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SaleReportService {
  apiUrl = environment.serverUrl;
  constructor(private http:HttpClient) { }
  public getSaleReport(str:string[]): Observable<SaleModel> {
    const url = this.apiUrl+`/reports/sale-report`;
    return this.http.post<any>(url,str); 
}
public getIncidentReport(map:any): Observable<any> {
  const url = this.apiUrl+`/reports/get-incident`;
  return this.http.post<any>(url,map); 
}
public getAppreciationReport(map:any): Observable<any> {
  const url = this.apiUrl+`/reports/get-appreciation`;
  return this.http.post<any>(url,map); 
}
public getOpenEscalationReport(id) {
  const url = this.apiUrl + `/reports/open-escalation-report/${id}`;
  return this.http.get<any>(url);
}
}
